export default __webpack_public_path__ + "media/images/icons/spinner-c9fd7edf12693be7830f7426be9d5062.svg";